import {Component, EventEmitter} from '@angular/core';
import {SvgIconComponent} from "../svg-icon/svg-icon.component";
import {HasCloseEvent} from "../../interfaces/has-close-event.interface";
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-comment',
  standalone: true,
  imports: [
    SvgIconComponent,
    TranslocoDirective
  ],
  templateUrl: './comment.component.html',
  styleUrl: './comment.component.scss'
})
export class CommentComponent implements HasCloseEvent{
  public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>;
  public data: string = "";

}
